// deprecated: use helpers scrollTo

let supportsSmooth: boolean | undefined;

const testSupportsSmoothScroll = () => {
  try {
    const div = document.createElement("div");
    div.scrollTo({
      top: 0,
      get behavior(): ScrollBehavior {
        supportsSmooth = true;
        return "smooth";
      }
    });
  } catch {
    supportsSmooth = false;
  }
};

const scrollToLeft = (elem: HTMLElement | null | undefined, left: number): void => {
  if (supportsSmooth === undefined) {
    testSupportsSmoothScroll();
  }

  if (!elem) {
    return; // just in case;
  }

  if (supportsSmooth) {
    elem.scrollTo({ behavior: "smooth", left, top: 0 });
  } else {
    elem.scrollTo(left, 0);
    // ie or safari most likely -> no animation
  }
};

export default scrollToLeft;
